export const environment = {
  production: true,
  apiBaseUrl: 'https://apiprepro.deporweb.net/api/',
  idCenter: null,
  idAppMulticentro: null,
  clienteAPI: 'myclub',
  passClienteAPI: '7Gq</5<r8mT3'
};
